<template>
  <div>
    <Modal :options="{width: '80vw', close:true, esc:false}" @close="$emit('close')">
      <div class="title">{{ titulo }}</div>
      <div class="body">
        <div class="row mb-3">
          <div class="col-sm-12">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a :class="css_tab_activo('general')" @click.prevent="tab_activo = 'general'" href="#">General</a>
              </li>
              <li v-if="area.id" class="nav-item">
                <a :class="css_tab_activo('usuarios')" @click.prevent="tab_activo = 'usuarios'" href="#">Usuarios</a>
              </li>
              <li v-if="area.id" class="nav-item">
                <a :class="css_tab_activo('etapas')" @click.prevent="tab_activo = 'etapas'" href="#">Etapas</a>
              </li>
              <li v-if="area.id" class="nav-item">
                <a :class="css_tab_activo('requerimientos')" @click.prevent="tab_activo = 'requerimientos'">Requerimientos</a>
              </li>
            </ul>
          </div>
        </div>

        <div v-if="tab_activo == 'general'" class="row">
          <div class="col-sm-12">
            <General :area="area" @update="obtener_area" />
          </div>
        </div>
        <div v-if="area.id && tab_activo == 'usuarios'" class="row">
          <div class="col-sm-12">
            <Usuario :area="area" @update="obtener_area" />
          </div>
        </div>
        <div v-if="area.id && tab_activo == 'etapas'" class="row">
          <div class="col-sm-12">
            <Etapa :area="area" @update="obtener_area" />
          </div>
        </div>
        <div v-if="area.id && tab_activo == 'requerimientos'" class="row">
          <div class="col-sm-12">
            <Requerimiento :area="area" @update="obtener_area" />
          </div>
        </div>
      </div>
      <div class="footer"></div>
    </Modal>
  </div>
</template>

<script>
  import Modal from '@/components/Modal';

  import General from './Detalle/General';
  import Usuario from './Detalle/Usuario';
  import Etapa from './Detalle/Etapa';
  import Requerimiento from './Detalle/Requerimiento';

  import apiAreas from '@/apps/tickets/api/areas';

  export default {
    components: {
      Modal,General,Usuario,Etapa,Requerimiento
    }
    ,data() {
      return {
        tab_activo: 'general',
        area: {
          id: null,
          nombre: null,
          usuarios: [],
          etapas: [],
          requerimientos: []
        }
      }
    }
    ,mounted() {
      if (this.area_id)
        this.obtener_area();
    }
    ,methods: {
      async obtener_area(area) {
        try {
          if (area) {
            this.$log.info('nueva area: ',area);
            this.$emit('up', area);
            return;
          }

          this.$log.info('cargamos las areas 1');
          this.area = (await apiAreas.obtener_area(this.area_id)).data;
          this.is_loaded = true;
        }catch(e) {
          this.$log.info('error',e);
          this.$helper.showAxiosError(e,'Error');
        }
      },
      css_tab_activo(tab) {
        let clases = 'nav-link';

        if (this.tab_activo == tab)
          clases += ' active';

        return clases;
      }
    }
    ,computed: {
      titulo() {
        return this.area.nombre ? this.area.nombre : 'Nueva área';
      }
    }
  }
</script>